import { arrayOf, func, number } from 'prop-types';
import React from 'react';
import { Alert } from 'reactstrap';

import { approvalShape } from '../prop-types';
import api from '../REST/api';
import withResolved from '../REST/with-resolved';
import { COLORS } from '../utils/constants';
import getEventTargetValue from '../utils/get-event-target-value';
import Approval from './Approval';
import APPROVAL_TYPES from './approval-types';
import { APPROVAL_TYPES as APPROVE_TYPES } from './constants';
import CreateApprovalButton from './CreateApprovalButton';

const forThisQuote = (quoteId, approval) =>
  !approval.quoteId || approval.quoteId === quoteId;

const renderOnlyQuoteApprovals = approval =>
  approval.type === APPROVE_TYPES.creatives;

const renderOnlyOppApprovals = approval =>
  approval.type !== APPROVE_TYPES.creatives;

class ApprovalsContainer extends React.Component {
  state = { teamId: null };

  onTeamChange = event => {
    this.setState({ teamId: getEventTargetValue(event.target) });
  };

  render() {
    const { objectId, approvals, quoteId, reload } = this.props;
    // If we are in a quote, filter out approvals for other quotes and only render zms creative for quote
    const relevantApprovals = quoteId
      ? approvals.filter(
          approval =>
            forThisQuote(quoteId, approval) &&
            renderOnlyQuoteApprovals(approval),
        )
      : approvals.filter(approval => renderOnlyOppApprovals(approval));
    const { teamId } = this.state;
    return (
      <>
        {APPROVAL_TYPES.map(
          TYPE =>
            TYPE.mayRequest(relevantApprovals, quoteId) && (
              <Alert key={TYPE.type} color="info">
                <p className="mb-3">{TYPE.reason}</p>
                <p className="mb-2">
                  {TYPE.whoCanGrant(teamId, this.onTeamChange)}
                </p>
                <p className="mb-3">They will be notified per email.</p>
                <CreateApprovalButton
                  opportunityId={objectId}
                  onSuccess={reload}
                  color={COLORS.PRIMARY}
                  data={TYPE.seedData(quoteId)}
                />
              </Alert>
            ),
        )}
        {relevantApprovals.map(approval => (
          <Approval key={approval.id} model={approval} />
        ))}
      </>
    );
  }
}

ApprovalsContainer.propTypes = {
  objectId: number.isRequired,
  approvals: arrayOf(approvalShape.isRequired).isRequired,
  reload: func.isRequired,
  quoteId: number,
};

ApprovalsContainer.defaultProps = {
  quoteId: undefined,
};

export default withResolved({
  query: api.getApprovals,
  deriveQueryArgs: ({ objectId }) => objectId,
  as: 'approvals',
})(ApprovalsContainer);
